import React, { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { useField } from 'react-form'

const Container = styled.div`
  position: relative;
`

const CoursesContainer = styled.div`
  background-color: #f8f8f8;
  display: flex;
  overflow-x: auto;
  padding: 1rem;
  margin: 2rem 0;

  ${(props) => {
    if (props.errored) {
      return `
        background: #f7cfd4 !important;
      `
    }
  }}
`

const DatumContainer = styled.div`
  padding: 1rem;
  min-width: ${(props) => props.width || 178}px;

  & h4 {
    text-align: center;
  }

  & hr {
    background: black;
  }

  & button {
    background: transparent;
    border: none;
    display: block;
    text-align: center;
    width: 100%;
    height: 50px;
    font-weight: 700;

    & small {
      display: inline-block;
      font-weight: normal;
    }
  }
`

const Button = styled.button(
  {
    color: 'black',
    cursor: 'pointer',
    '&:focus': {
      outline: 0,
    },
    '&:hover': {
      border: '1px solid black',
    },
  },
  (props) => {
    if (props.selected) {
      return {
        background: 'black !important',
        color: 'white',
      }
    }
  }
)

const ArrowButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;

  display: flex;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 70%
  );
`

const RequiredEM = styled.span`
  color: #c15561;
`

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect()

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

const CourseSelector = ({
  data,
  columnWidth = 178,
  formId,
  selectable = false,
}) => {
  const {
    value = [],
    meta: { error, isTouched },
    setValue,
  } = useField(formId, {
    validate: (value) =>
      value && value.length > 0
        ? false
        : 'Bitte wähle mindestens einen Kurs aus',
  })

  const [showArrowForOverflow, setShowArrowForOverflow] = useState(false)

  const handleSelect = (selected) => {
    if (!selectable) return

    if (value.includes(selected)) {
      setValue(value.filter((item) => item !== selected))
      return
    }

    // Set the new values, but filter every course on same day
    setValue([selected, ...value])
  }

  const refs = useRef({})

  useEffect(() => {
    setShowArrowForOverflow(
      Object.entries(refs.current)
        .map(([, element]) => isInViewport(element))
        // When there is one 'false' in the array, regardless of order we return 'true'
        .reduce((acc, currentValue) => acc || !currentValue, false)
    )
  }, [refs.current])

  return (
    <Container>
      <CoursesContainer errored={isTouched && error}>
        {data.map((datum) => (
          <DatumContainer
            ref={(el) => (refs.current[datum.id] = el)}
            width={columnWidth}
            key={datum.title}
          >
            <h4>{datum.title}</h4>
            <hr />
            {datum.options.map((option) => {
              const id = `${datum.id}-${option.id}`

              return (
                <div key={option.id}>
                  <Button
                    type="button"
                    onClick={() => handleSelect(id)}
                    selected={value.includes(id)}
                  >
                    {option.label}
                    <small>{option.sublabel}</small>
                  </Button>
                </div>
              )
            })}
          </DatumContainer>
        ))}
      </CoursesContainer>

      {showArrowForOverflow && <ArrowButtonContainer />}

      {isTouched && <RequiredEM>{error}</RequiredEM>}
    </Container>
  )
}

export default CourseSelector
